export const getNextPrevIndex = ({
  setLength,
  currentIndex,
}: {
  setLength: number
  currentIndex: number
}) => ({
  nextIndex: (currentIndex + 1) % setLength,
  prevIndex: currentIndex === 0 ? setLength - 1 : currentIndex - 1,
})
